<template>
  <div id="banner" class="q-my-xs q-py-xs" v-if="!show_img">
    <banner />
  </div>

  <div id="content" v-if="!show_img">
    <div class="contentbody">
      <q-tabs v-model="tab" dense class="text-grey" active-color="primary" indicator-color="primary" align="justify">
        <q-tab name="quotes_tab" label="报价" />
        <q-tab name="example_tab" label="菜单模板介绍" />
      </q-tabs>

      <q-separator />

      <q-tab-panels v-model="tab" animated>
        <q-tab-panel name="quotes_tab">
          <div class="q-mb-sm">
            <q-banner class="bg-positive text-white">
              <div class="row full-width items-center content-center">
                <div class="col q-pr-xl">
                  <q-input v-model="search_system_name" dark dense autocomplete="off">
                    <template v-slot:before>
                      <div class="text-body1 text-white">系统名称<label class="text-red">*</label></div>
                    </template>
                  </q-input>
                </div>

                <div class="col q-pr-xl">
                  <q-input v-model="search_password" type="password" dark dense autocomplete="off">
                    <template v-slot:before>
                      <div class="text-body1 text-white">搜索密码<label class="text-red">*</label></div>
                    </template>
                  </q-input>
                </div>

                <div class="col-1">
                  <q-btn color="primary" @click="search_quotes">搜索</q-btn>
                </div>
              </div>
            </q-banner>
          </div>

          <div class="">
            <q-banner class="bg-primary text-white">
              <div class="row full-width justify-between items-center content-center">
                <!-- <div class="col-1">
              报价
            </div> -->
                <div class="col-auto">
                  <div class="row full-width justify-center items-center content-center q-gutter-md">
                    <div class="col-auto text-h6 text-weight-bolder">
                      <!-- 总金额：￥{{ main_data["total_amount"] }} -->
                      <q-input borderless v-model="main_data['total_amount']" type="number" dark dense autocomplete="off"
                        readonly>
                        <template v-slot:before>
                          <div class="text-body1 text-white">总金额 ￥</div>
                        </template>
                      </q-input>
                    </div>
                    <div class="col">
                      <q-select v-model="main_data['buy_years']" :options="buy_years_options" borderless dark
                        transition-show="scale" transition-hide="scale" @update:model-value="select_buy_years">
                        <template v-slot:before>
                          <div class="text-body1 text-white">购买年限</div>
                        </template>
                      </q-select>
                    </div>
                    <div class="col">
                      <q-input borderless v-model="discount_amount" dark dense autocomplete="off" readonly>
                        <template v-slot:before>
                          <div class="text-body1 text-white">折后价 ￥</div>
                        </template>
                      </q-input>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-auto">
              <q-btn color="secondary"
                @click="$q.localStorage.remove('jl_quotes_main_data'); $q.localStorage.remove('jl_quotes_menu_data')">
                清除本地缓存
                <q-tooltip class=""></q-tooltip>
              </q-btn>
            </div> -->
                <div class="col-auto">
                  <q-btn color="secondary" @click="submit_quotes">
                    提交报价
                    <q-tooltip class="">我们会尽快与您联系，感谢您的支持！</q-tooltip>
                  </q-btn>
                </div>
              </div>
            </q-banner>

            <div class="column">
              <div class="col">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 q-pr-xl">
                    <q-input name="name" v-model="main_data['system_name']" color="primary" clearable dense
                      autocomplete="off">
                      <template v-slot:before>
                        <div class="text-body1 text-black">系统名称<label class="text-red">*</label></div>
                      </template>
                    </q-input>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 q-pr-xl">
                    <q-input name="name" v-model="main_data['search_password']" type="password" color="primary" clearable
                      dense autocomplete="off">
                      <template v-slot:before>
                        <div class="text-body1 text-black">搜索密码<label class="text-red">*</label></div>
                      </template>
                    </q-input>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 q-pr-xl">
                    <q-input name="name" v-model="main_data['confirm_password']" type="password" color="primary" clearable
                      dense autocomplete="off">
                      <template v-slot:before>
                        <div class="text-body1 text-black">验证搜索密码<label class="text-red">*</label></div>
                      </template>
                    </q-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 q-pr-xl">
                    <q-input name="name" v-model="main_data['contact_person']" color="primary" clearable dense
                      autocomplete="off">
                      <template v-slot:before>
                        <div class="text-body1 text-black">联系人<label class="text-red">*</label></div>
                      </template>
                    </q-input>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 q-pr-xl">
                    <q-input name="name" v-model="main_data['contact_number']" color="primary" clearable dense
                      autocomplete="off">
                      <template v-slot:before>
                        <div class="text-body1 text-black">联系电话<label class="text-red">*</label></div>
                      </template>
                    </q-input>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 q-pr-xl">
                    <q-input name="name" v-model="main_data['wechat']" color="primary" clearable dense autocomplete="off">
                      <template v-slot:before>
                        <div class="text-body1 text-black">微信/QQ</div>
                      </template>
                    </q-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 q-pr-xl">
                    <q-input name="name" type="textarea" autogrow v-model="main_data['remark']" color="primary" clearable
                      dense autocomplete="off">
                      <template v-slot:before>
                        <div class="text-body1 text-black">备注</div>
                      </template>
                    </q-input>
                  </div>
                </div>
              </div>

              <q-separator class="q-my-sm" />

              <div class="col">
                <div class="row full-width">
                  <q-banner class="col-12 bg-blue-1 text-white">
                    <div class="row full-width items-center content-center q-pb-xs">
                      <div class="col">
                        <div class="text-body1 text-black q-pr-xl">当前选中菜单：{{ current_menu }}</div>
                      </div>
                      <div class="col">
                        <div class="text-body1 text-black q-pr-xl">当前菜单价格：{{ current_menu_total }}</div>
                      </div>
                    </div>
                    <div class="row full-width items-center content-center">
                      <div class="col">
                        <div class="row items-center content-center q-gutter-md">
                          <q-btn color="blue-10" @click="add_main_menu" :disable="edit_state != ''">
                            增加 主菜单
                            <q-tooltip class="">增加一个主菜单</q-tooltip>
                          </q-btn>
                          <q-btn color="blue-6" @click="add_sub_menu(menu_item['id'])" :disable="(edit_state != '')">
                            增加 子菜单
                            <q-tooltip class="">增加一个子菜单</q-tooltip>
                          </q-btn>
                          <q-btn color="positive" @click="edit_menu"
                            :disable="((menu_item['id'] == 0) || (edit_state != ''))">
                            修改
                            <q-tooltip class="">修改当前的菜单</q-tooltip>
                          </q-btn>
                          <q-btn color="negative" @click="delete_menu(menu_item['id'])"
                            :disable="((menu_item['id'] == 0) || (edit_state != ''))">
                            删除
                            <q-tooltip class="">连同子菜单一起删除</q-tooltip>
                          </q-btn>
                        </div>
                      </div>
                      <div class="col-auto q-gutter-md">
                        <q-btn color="positive" @click="save_menu" :disable="edit_state == ''">保存菜单</q-btn>
                        <q-btn color="amber-10" @click="cancel_menu" :disable="edit_state == ''">取消</q-btn>
                        <q-btn color="info" @click="rewrite_menu" :disable="edit_state == ''">重填</q-btn>
                      </div>
                    </div>
                  </q-banner>
                </div>

                <div class="row full-width">
                  <div class="col q-pa-md" style="max-width: 350px">
                    <q-list bordered class="rounded-borders">
                      <label v-if="menu_data.length == 0">暂无菜单</label>
                      <q-expansion-item expand-icon-toggle default-opened
                        v-for="( main_menu, main_menu_index ) in  menu_data " :key="main_menu.id">
                        <template v-slot:header class="expansion">
                          <div class="row full-width items-center expansion"
                            :class="((main_menu.id == current_menu_main_index) && (current_menu_sub_index == -1)) ? 'menu_active' : '', edit_state != '' ? 'div-disable' : ''"
                            @click="edit_state == '' ? click_menu(main_menu_index) : null"
                            :style="{ backgroundColor: 'rgba(173, 173, 173, 0.2)' }">
                            <label class="q-pl-sm" :class="edit_state != '' ? 'div-disable' : ''">{{
                              main_menu.menu_name }}</label>
                          </div>
                        </template>
                        <q-expansion-item :header-inset-level="1" hide-expand-icon
                          v-for="( sub_menu, sub_menu_index ) in  main_menu['sub'] " :key="sub_menu.id">
                          <template v-slot:header class="expansion">
                            <div class="row full-width items-center expansion"
                              :class="((main_menu.id == current_menu_main_index) && (sub_menu.id == current_menu_sub_index)) ? 'menu_active' : '', edit_state != '' ? 'div-disable' : ''"
                              @click="edit_state == '' ? click_sub_menu(main_menu_index, sub_menu_index) : null">
                              <label class="q-pl-sm" :class="edit_state != '' ? 'div-disable' : ''">{{
                                sub_menu.menu_name }}</label>
                            </div>
                          </template>
                        </q-expansion-item>
                      </q-expansion-item>
                    </q-list>
                  </div>
                  <div class="col-grow q-pa-md">
                    <div class="row">
                      <div class="col-12 q-pr-xl">
                        <q-input name="name" v-model="menu_item['menu_name']" color="primary" clearable dense
                          autocomplete="off" :readonly="edit_state == ''">
                          <template v-slot:before>
                            <div class="text-body1 text-black">菜单名称<label class="text-red">*</label></div>
                          </template>
                        </q-input>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 q-pr-xl">
                        <q-input name="name" type="textarea" autogrow v-model="menu_item['description']" color="primary"
                          clearable dense autocomplete="off" :readonly="edit_state == ''">
                          <template v-slot:before>
                            <div class="text-body1 text-black">功能描述</div>
                          </template>
                        </q-input>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 q-pr-xl">
                        <div class="row items-center content-center">
                          <div class="text-body1 text-black">菜单模板<q-btn flat color="blue-10" @click="cancel_menu_type"
                              :disable="edit_state == ''">取消选择</q-btn></div>
                          <q-option-group v-model="menu_item['menu_type']" :options="menu_type" inline
                            :disable="edit_state == ''" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 q-pr-xl">
                        <div class="row items-center content-center">
                          <div class="text-body1 text-black">是否需要审核</div>
                          <q-radio :disable="edit_state == ''" v-model="menu_item['can_audit']" val="1" label="是" />
                          <q-radio :disable="edit_state == ''" v-model="menu_item['can_audit']" val="0" label="否" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 q-pr-xl">
                        <div class="row items-center content-center">
                          <div class="text-body1 text-black">扩展功能</div>
                          <q-option-group type="checkbox" v-model="menu_item['extensions']" :options="extensions" inline
                            :disable="edit_state == ''" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 q-pr-xl">
                        <q-input name="name" v-model="current_base_amount" color="primary" clearable dense readonly
                          autocomplete="off">
                          <template v-slot:before>
                            <div class="text-body1 text-black">基础金额</div>
                          </template>
                        </q-input>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 q-pr-xl">
                        <q-input name="name" type="textarea" autogrow v-model="menu_item['other_function']"
                          color="primary" clearable dense autocomplete="off" :readonly="edit_state == ''">
                          <template v-slot:before>
                            <div class="text-body1 text-black">其他功能</div>
                          </template>
                        </q-input>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 q-pr-xl">
                        <q-input name="name" v-model="menu_item['other_amount']" type="number" color="primary" clearable
                          dense autocomplete="off" :readonly="edit_state == ''">
                          <template v-slot:before>
                            <div class="text-body1 text-black">其他金额</div>
                          </template>
                        </q-input>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 q-pr-xl">
                        <q-input name="name" v-model="menu_item['sort_order']" type="number" color="primary" clearable
                          dense autocomplete="off" :readonly="edit_state == ''">
                          <template v-slot:before>
                            <div class="text-body1 text-black">排序</div>
                          </template>
                        </q-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-tab-panel>

        <q-tab-panel name="example_tab" class="q-pa-none">

          <Rotation />

        </q-tab-panel>


      </q-tab-panels>



    </div>
  </div>
</template>
  
<script>
import { useQuasar } from "quasar";
import { request } from "@/request/api";
import { useI18n } from "vue-i18n";
import { ref, watch, computed } from "vue";
import { fasFont } from '@quasar/extras/fontawesome-v5';

import Banner from './Banner.vue';
import Rotation from './Rotation.vue';


export default {
  name: "quotes",
  components: {
    Banner,
    Rotation,
  },
  setup(props, context) {
    const $q = useQuasar()

    // 布局
    const main_menu = ref([]);
    const sub_menu = ref([]);

    const show_img = ref(false);
    const current_img = ref("./img/base_data.png");

    // 数据
    // 报表单表头数据
    const main_data = ref({});

    // 菜单项当前最大ID
    let max_id = 0;
    // 主菜单数据
    const menu_data = ref([]); // 菜单数据

    // 当前编辑菜单项
    const menu_item = ref({});
    // 菜单初始化值
    let menu_item_ini = {};
    // 重填菜单数据
    let menu_item_reset = {};

    // 当前主菜单id
    const current_menu_main_index = ref(-1);
    // 当前子菜单id
    const current_menu_sub_index = ref(-1);
    // 当前菜单名称
    const current_menu = ref("");

    // 最大排序序号
    let max_sort_order = 0;

    // 编辑状态 "edit" "new"
    const edit_state = ref("");

    // 搜索条件
    const search_system_name = ref("");
    const search_password = ref("");

    // 初始化数据
    main_data.value["id"] = 0;
    main_data.value["system_name"] = "";
    main_data.value["search_password"] = "";
    main_data.value["confirm_password"] = "";
    main_data.value["contact_person"] = "";
    main_data.value["contact_number"] = "";
    main_data.value["wechat"] = "";
    main_data.value["remark"] = "";
    main_data.value["total_amount"] = "";
    main_data.value["buy_years"] = "1";
    main_data.value["discount"] = 0;

    menu_item_ini["id"] = 0;
    menu_item_ini["main_id"] = "";
    menu_item_ini["parent_id"] = 0;
    menu_item_ini["menu_name"] = "";
    menu_item_ini["description"] = "";
    menu_item_ini["menu_type"] = null;
    menu_item_ini["can_audit"] = 0;
    menu_item_ini["menu_amount"] = 0;
    menu_item_ini["extensions"] = [];
    menu_item_ini["extensions_amount"] = 0;
    menu_item_ini["base_amount"] = 0;
    menu_item_ini["other_function"] = "";
    menu_item_ini["other_amount"] = 0;
    menu_item_ini["sort_order"] = 0;
    menu_item_ini["sub"] = [];

    menu_item_reset = JSON.parse(JSON.stringify(menu_item_ini));
    menu_item.value = JSON.parse(JSON.stringify(menu_item_ini));

    // console.log(menu_item.value);
    // console.log(menu_item_ini);
    // console.log(JSON.stringify(menu_item_ini));

    const menu_type = ref([]);
    const extensions = ref([]);
    const buy_years_options = ref([]);

    // console.log(($q.localStorage.getItem("jl_quotes_main_data")));

    let temp_main_data = $q.localStorage.getItem("jl_quotes_main_data");
    let temp_menu_data = $q.localStorage.getItem("jl_quotes_menu_data");

    menu_data.value = ((typeof (temp_menu_data) !== "undefined") && (temp_menu_data != null)) ? temp_menu_data : menu_data.value;
    main_data.value = ((typeof (temp_main_data) !== "undefined") && (temp_main_data != null)) ? temp_main_data : main_data.value;

    // 获取临时菜单的最大id
    Object.values(menu_data.value).forEach((main_menu) => {
      max_id = main_menu.id > max_id ? main_menu.id : max_id;
      Object.values(main_menu.sub).forEach((sub_menu) => {
        max_id = sub_menu.id > max_id ? sub_menu.id : max_id;
      })
    })

    max_id++;

    main_data.value["total_amount"] = calculateTotalAmount(menu_data.value);

    // 获取菜单类型
    request("get_table", {
      table_name: "v_menu_type",
      order_by: "sort_order",
    }).then((res) => {
      menu_type.value = res;
    });

    // 获取扩展功能
    request("get_table", {
      table_name: "v_extensions_function",
      order_by: "sort_order",
    }).then((res) => {
      extensions.value = res;
    });

    // 获取购买年限
    request("get_select_option_all", {
      menu_name: "quotes",
      table_name: "t_quotes",
      form_type: "edit",
    }).then((options) => {
      buy_years_options.value = Object.values(options).find(Array.isArray);

      for (var i = 0; i < buy_years_options.value.length; i++) {
        var item = buy_years_options.value[i];
        var discountValue = parseFloat(item.discount);

        if (discountValue === 0) {
          // 如果discount为0，则不修改label
          item.label = item.label + " (无折扣)";
        } else if (discountValue > 1) {
          // 如果discount大于1，则直接减
          item.label = item.label + " (折减" + discountValue + "元)";
        } else if (discountValue > 0 && discountValue < 1) {
          // 如果discount在0到1之间，则*100加上%
          item.label = item.label + " (" + (discountValue * 100) + "折)";
        }
      }

      main_data.value["buy_years"] = buy_years_options.value.find(option => option.id === main_data.value["buy_years"]);
    });

    function cancel_menu_type() {
      menu_item.value["menu_type"] = null;
    }

    // 监察报价表头数据变化
    watch(main_data.value, () => {
      // $q.localStorage.set("jl_quotes_main_data", main_data.value);
    });

    // 监察菜单类型变化
    watch(
      () => menu_item.value["menu_type"],
      () => {
        menu_item.value["menu_amount"] = 0;

        menu_type.value.forEach(function (item) {
          if (item["id"] === menu_item.value["menu_type"]) {
            menu_item.value["menu_amount"] = item["price"];
            // 找到后退出循环
            return;
          }
        });
      }
    );

    // 监察扩展功能变化
    watch(
      () => menu_item.value["extensions"],
      () => {
        // 使用 reduce 计算匹配ID的元素的 price 总和
        let totalPrice = Object.values(menu_item.value["extensions"]).reduce((sum, id) => {
          let matchingItem = extensions.value.find(item => item.id === id);
          if (matchingItem) {
            return sum + parseFloat(matchingItem.price);
          }
          return sum;
        }, 0);

        menu_item.value["extensions_amount"] = totalPrice; // 输出总和
      }
    );

    // 计算当前菜单小计
    const current_menu_total = computed(() => {
      return parseFloat(current_base_amount.value) + parseFloat(menu_item.value["other_amount"]);
    });

    // 计算当前菜单基础功能金额
    const current_base_amount = computed(() => {
      return parseFloat(menu_item.value["menu_amount"]) + parseFloat(menu_item.value["extensions_amount"]);;
    });

    // 选择购买年限
    function select_buy_years(value) {
      main_data.value["discount"] = main_data.value['buy_years'].discount
    }

    // 计算折后总金额
    const discount_amount = computed(() => {
      let ta = parseFloat(main_data.value["total_amount"]);
      let dsc = parseFloat(main_data.value["discount"]);
      let ret = 0;

      if ((dsc >= 1) || (dsc == 0)) {
        ret = ta - dsc;
      } else {
        ret = parseFloat(ta) * parseFloat(dsc).toFixed(2);
        ret = Math.round(ret);
      }
      if (ret > 0) {
        ret = ret + "/年*" + main_data.value['buy_years'].name + "=" + Math.round(ret * parseFloat(main_data.value['buy_years'].years));
      }
      return ret;
    });

    // 增加主菜单
    function add_main_menu() {
      menu_item.value = JSON.parse(JSON.stringify(menu_item_ini));
      menu_item.value["id"] = max_id++;
      menu_item.value["parent_id"] = 0;

      menu_item.value["sort_order"] = menu_data.value.length + 1;

      edit_state.value = "new";
    }

    // 增加子菜单
    function add_sub_menu(menu_id) {
      let parent_id = menu_id;

      // 找出父菜单
      Object.values(menu_data.value).forEach((item) => {
        if (item.id == menu_id) {
          parent_id = menu_id;
          max_sort_order = item.sub.length + 1;
        } else {
          Object.values(item.sub).forEach((sub_item) => {
            if (sub_item.id == menu_id) {
              parent_id = sub_item.parent_id;
              max_sort_order = item.sub.length + 1;
            }
          })
        }
      });

      menu_item.value = JSON.parse(JSON.stringify(menu_item_ini));
      menu_item.value["id"] = max_id++;
      menu_item.value["parent_id"] = parent_id;
      menu_item.value["sort_order"] = max_sort_order;

      edit_state.value = "new";
    }

    // 修改菜单
    function edit_menu() {
      edit_state.value = "edit";
      // console.log(edit_state.value);
    }

    // 删除菜单
    function delete_menu() {
      let ask = "是否删除菜单：" + current_menu.value;

      if (current_menu_sub_index.value == -1) {
        // 主菜单
        ask += '（包括所有子菜单）';
      }
      ask += "？";

      // 没有编辑的菜单!
      $q.dialog({
        // title: ask,
        message: ask,
        // color: "red-5",
        // style: "background: #ffebee"
        cancel: true,
        persistent: true
      }).onOk(() => {
        // console.log('OK')
        let menu_index = get_menu_index(current_menu_main_index.value, current_menu_sub_index.value);

        let main_index = menu_index[0];
        let sub_index = menu_index[1];

        if (current_menu_sub_index.value == -1) {
          // 主菜单
          menu_data.value.splice(main_index, 1);
        } else {
          // 子菜单
          menu_data.value[main_index].sub.splice(sub_index, 1);
        }

        main_data.value["total_amount"] = calculateTotalAmount(menu_data.value);

        save_local_menu();
      }).onCancel(() => {
        // console.log('Cancel')
      }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
      })
    }

    // 取消菜单
    function cancel_menu() {
      menu_item.value = JSON.parse(JSON.stringify(menu_item_reset));

      edit_state.value = "";
    }

    // 重填菜单
    function rewrite_menu() {
      menu_item.value = JSON.parse(JSON.stringify(menu_item_reset));
    }

    // 保存菜单
    function save_menu() {
      // 检查合法性
      // 保存到临时数组
      // console.log(edit_state.value);
      if (edit_state.value != "") {
        // 检查数据有效性
        let can_save = true;
        let msg = "";

        // 找出主、子菜单下标
        let menu_index = get_menu_index(current_menu_main_index.value, current_menu_sub_index.value);

        let main_index = menu_index[0];
        let sub_index = menu_index[1];

        // 菜单名称不能为空
        if (((menu_item.value.menu_name == null) || (menu_item.value.menu_name.trim() == "")) && can_save) {
          can_save = false;
          msg = "菜单名称不能为空！";
        }

        // 菜单名称不能重复
        if (can_save) {
          Object.values(menu_data.value).forEach((main_menu) => {
            if (can_save) {
              if ((main_menu.menu_name == menu_item.value.menu_name) && (main_menu.id != current_menu_main_index.value)) {
                // console.log(main_menu.menu_name, menu_item.value.menu_name);
                // console.log(main_menu.id, current_menu_main_index.value);

                can_save = false;
                msg = "菜单名称已经存在";
              }

              if (can_save) {
                Object.values(main_menu.sub).forEach((sub_menu) => {
                  if ((sub_menu.menu_name == menu_item.value.menu_name) && (sub_menu.id != current_menu_sub_index.value)) {
                    // console.log(sub_menu.menu_name, menu_item.value.menu_name);
                    // console.log(sub_menu.id, current_menu_sub_index.value);

                    can_save = false;
                    msg = "菜单名称已经存在";
                  }
                })
              }
            }
          })
        }

        // 所有数据有效，保存
        if (can_save) {
          if (edit_state.value == "new") {
            // 新增
            let parent_id = menu_item.value["parent_id"];

            if (parent_id > 0) {
              // 当前为子菜单

              // 找出父菜单
              Object.values(menu_data.value).forEach((item) => {
                if (item.id == parent_id) {
                  item["sub"].push(menu_item.value);
                }
              });

              current_menu_sub_index.value = menu_item.value["id"];
              current_menu_main_index.value = parent_id;
            } else {
              menu_data.value.push(JSON.parse(JSON.stringify(menu_item.value)));

              current_menu_sub_index.value = -1;
              current_menu_main_index.value = menu_item.value["id"];
            }

            edit_state.value = "";

            current_menu.value = menu_item.value["menu_name"];

            insertAndUpdate(menu_item.value.id, menu_item.value.sort_order);
          } else if (edit_state.value == "edit") {
            let oldSortIndex = 0;
            // 修改
            if (current_menu_sub_index.value == -1) {
              oldSortIndex = menu_data.value[main_index].sort_order;
              menu_data.value[main_index] = JSON.parse(JSON.stringify(menu_item.value));
            } else {
              Object.keys(menu_data.value[main_index].sub).forEach((sub_key) => {
                if (menu_data.value[main_index].sub[sub_key].id == current_menu_sub_index.value) {
                  sub_index = sub_key;
                }
              })

              oldSortIndex = menu_data.value[main_index].sub[sub_index].sort_order;
              menu_data.value[main_index].sub[sub_index] = JSON.parse(JSON.stringify(menu_item.value));
            }

            edit_state.value = "";

            updateSortIndex(menu_item.value.id, oldSortIndex, menu_item.value.sort_order);
          }

          main_data.value["total_amount"] = calculateTotalAmount(menu_data.value);
        } else {
          // 没有编辑的菜单!
          $q.dialog({
            // title: msg,
            message: msg,
            color: "red-5",
            // style: "background: #ffebee"
          }).onOk(() => {
            // console.log('OK')
          }).onCancel(() => {
            // console.log('Cancel')
          }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          })
        }
      } else {
        // 没有编辑的菜单!
        $q.dialog({
          title: '没有编辑的菜单!',
          // message: '没有编辑的菜单!'
          color: "red-5",
          // style: "background: #ffebee"
        }).onOk(() => {
          // console.log('OK')
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
      }

      save_local_menu();
    }

    // 定义一个函数来插入新值并更新排序索引
    function insertAndUpdate(id, sort_order) {
      let menu_index = get_menu_index(current_menu_main_index.value, current_menu_sub_index.value);

      let main_index = menu_index[0];
      let sub_index = menu_index[1];

      let custom_data = null;

      if (sub_index == -1) {
        custom_data = menu_data.value;
      }
      else {
        custom_data = menu_data.value[main_index].sub;
      }

      // 更新排序索引
      for (let i = 0; i < custom_data.length; i++) {
        if (custom_data[i].sort_order >= sort_order && custom_data[i].id !== id) {
          custom_data[i].sort_order = (parseInt(custom_data[i].sort_order) + 1).toString();
        }
      }

      // 重新按 sort_order 排序
      custom_data.sort((a, b) => parseInt(a.sort_order) - parseInt(b.sort_order));
    }

    // 定义一个函数来修改排序索引
    function updateSortIndex(id, oldSortIndex, newSortIndex) {
      let menu_index = get_menu_index(current_menu_main_index.value, current_menu_sub_index.value);

      let main_index = menu_index[0];
      let sub_index = menu_index[1];

      let custom_data = null;

      if (sub_index == -1) {
        custom_data = menu_data.value;
      }
      else {
        custom_data = menu_data.value[main_index].sub;
      }

      // const oldSortIndex = custom_data.find(item => item.id === id).sort_order;

      // console.log(oldSortIndex);

      // 更新其他项的排序索引
      for (let i = 0; i < custom_data.length; i++) {
        if (custom_data[i].id !== id) {
          if (newSortIndex < oldSortIndex) {
            if (custom_data[i].sort_order >= newSortIndex && custom_data[i].sort_order < oldSortIndex) {
              custom_data[i].sort_order = (parseInt(custom_data[i].sort_order) + 1).toString();
            }
          } else if (newSortIndex > oldSortIndex) {
            if (custom_data[i].sort_order <= newSortIndex && custom_data[i].sort_order > oldSortIndex) {
              custom_data[i].sort_order = (parseInt(custom_data[i].sort_order) - 1).toString();
            }
          }
        }
      }

      // 更新当前项的排序索引
      custom_data.find(item => item.id === id).sort_order = newSortIndex;

      // 重新按 sort_order 排序
      custom_data.sort((a, b) => parseInt(a.sort_order) - parseInt(b.sort_order));
    }

    // 递归函数来计算合计数
    function calculateTotalAmount(data) {
      return data.reduce((total, item) => {
        const subTotal = item.sub ? calculateTotalAmount(item.sub) : 0;
        return total + parseFloat(item.menu_amount) + parseFloat(item.extensions_amount) + parseFloat(item.other_amount) + subTotal;
      }, 0);
    }

    // 点击主菜单
    function click_menu(menu_index) {
      let tmp_menu = {};
      tmp_menu = menu_data.value[menu_index];

      menu_item.value = JSON.parse(JSON.stringify(tmp_menu));

      menu_item_reset = JSON.parse(JSON.stringify(menu_item.value));

      current_menu_main_index.value = tmp_menu["id"];
      current_menu_sub_index.value = -1;  //tmp_menu["id"];
      current_menu.value = tmp_menu['menu_name'];
    }

    // 点击子菜单
    function click_sub_menu(main_menu_index, sub_menu_index) {
      let tmp_menu = [];
      tmp_menu = JSON.parse(JSON.stringify(menu_data.value[main_menu_index]["sub"][sub_menu_index]));

      menu_item.value = tmp_menu;

      menu_item_reset = JSON.parse(JSON.stringify(menu_item.value));

      current_menu_main_index.value = menu_data.value[main_menu_index]["id"];
      current_menu_sub_index.value = tmp_menu["id"];
      current_menu.value = tmp_menu['menu_name'];
    }

    // 通过id获取当前选中菜单对应的下标
    function get_menu_index(main_id, sub_id) {
      let main_index = -1;
      let sub_index = -1;

      Object.keys(menu_data.value).forEach((key) => {
        if (menu_data.value[key].id == main_id) {
          main_index = key;
        }
      });

      if (current_menu_sub_index.value != -1) {
        Object.keys(menu_data.value[main_index].sub).forEach((sub_key) => {
          if (menu_data.value[main_index].sub[sub_key].id == sub_id) {
            sub_index = sub_key;
          }
        })
      }

      return [main_index, sub_index];
    }

    // 保存本地临时记录
    function save_local_menu() {
      // $q.localStorage.set("jl_quotes_menu_data", menu_data.value);
    }

    // 提交报价
    function submit_quotes() {
      // 检查合法性
      let submit_msg = submit_check();

      console.log("submit_msg", submit_msg);

      console.log(main_data.value);
      if (submit_msg == "") {
        main_data.value["menu"] = JSON.stringify(menu_data.value);

        console.log("typeof", typeof main_data.value["buy_years"]);

        if (typeof main_data.value["buy_years"] == "object") {
          main_data.value["buy_years"] = main_data.value["buy_years"].id;
        }

        // 提交数据
        request("save_data", {
          table_name: "t_quotes",
          menu_name: "quotes",
          data: main_data.value,
          user_info: $q.localStorage.getItem("user_info"),
        }).then((res) => {
          console.log(res);
          if (res.status == true) {
            main_data.value.buy_years = buy_years_options.value.find(option => option.id === main_data.value.buy_years);

            // 保存成功
            $q.dialog({
              // title: submit_msg,
              message: "保存成功！",
              color: "red-5",
              // style: "background: #ffebee"
            }).onOk(() => {
              // console.log('OK')
            }).onCancel(() => {
              // console.log('Cancel')
            }).onDismiss(() => {
              // console.log('I am triggered on both OK and Cancel')
            })
          } else {
            // 错误提示
            $q.dialog({
              // title: submit_msg,
              message: res.msg,
              color: "red-5",
              // style: "background: #ffebee"
            }).onOk(() => {
              // console.log('OK')
            }).onCancel(() => {
              // console.log('Cancel')
            }).onDismiss(() => {
              // console.log('I am triggered on both OK and Cancel')
            })
          }
        });
      } else {
        // 合法性提示
        $q.dialog({
          title: submit_msg,
          // message: '没有编辑的菜单!'
          color: "red-5",
          // style: "background: #ffebee"
        }).onOk(() => {
          // console.log('OK')
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
      }
    }

    function submit_check() {
      let can_save = true;
      let msg = "";

      // 1. 检查必填项
      // 菜单名称不能为空
      if (((main_data.value.system_name == null) || (main_data.value.system_name.trim() == "")) && can_save) {
        can_save = false;
        msg = "系统名称不能为空！";
      }

      if (((main_data.value.contact_person == null) || (main_data.value.contact_person.trim() == "")) && can_save) {
        can_save = false;
        msg = "联系人不能为空！";
      }

      if (((main_data.value.contact_number == null) || (main_data.value.contact_number.trim() == "")) && can_save) {
        can_save = false;
        msg = "联系电话不能为空！";
      }

      if (((main_data.value.search_password == null) || (main_data.value.search_password.trim() == "")) && can_save) {
        can_save = false;
        msg = "搜索密码不能为空！";
      }

      // 2. 检查密码是否一致
      if ((main_data.value.search_password.trim() != main_data.value.confirm_password.trim()) && can_save) {
        can_save = false;
        msg = "验证搜索密码不匹配";
      }

      // 3. 检查是否有菜单项
      if ((menu_data.value.length == 0) && can_save) {
        can_save = false;
        msg = "不能提交空白菜单";
      }

      // 4. 检查总金额是否为0
      if ((parseFloat(main_data.value["total_amount"]) == 0) && can_save) {
        can_save = false;
        msg = "不能提交总金额为0的报价";
      }

      return msg;
    }

    function search_quotes() {
      // 检查合法性
      if (search_system_name.value == "") {
        $q.dialog({
          // title: submit_msg,
          message: '搜索系统名称不能为空',
          color: "red-5",
          // style: "background: #ffebee"
        }).onOk(() => {
          // console.log('OK')
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })

        return false;
      }

      if (search_password.value == "") {
        $q.dialog({
          // title: submit_msg,
          message: '搜索密码不能为空',
          color: "red-5",
          // style: "background: #ffebee"
        }).onOk(() => {
          // console.log('OK')
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })

        return false;
      }

      // 搜索返回结果
      request("get_table", {
        table_name: "t_quotes",
        where: "system_name like '%" + search_system_name.value + "' and search_password=" + search_password.value,
      }).then((res) => {
        if (res.length > 0) {
          res = res[0];
          menu_data.value = JSON.parse(res.menu);

          main_data.value = { ...res };
          delete main_data.value.menu;
          main_data.value["confirm_password"] = main_data.value["search_password"]

          // 当前主菜单id
          current_menu_main_index.value = -1;
          // 当前子菜单id
          current_menu_sub_index.value = -1;
          // 当前菜单名称
          current_menu.value = "";

          // 最大排序序号
          max_sort_order = 0;

          // 编辑状态 "edit" "new"
          edit_state.value = "";

          menu_item.value = JSON.parse(JSON.stringify(menu_item_ini));
          main_data.value.buy_years = buy_years_options.value.find(option => option.id === main_data.value.buy_years);
        } else {
          // 错误提示
          $q.dialog({
            // title: submit_msg,
            message: "查无报价信息，请查正再试",
            color: "red-5",
            // style: "background: #ffebee"
          }).onOk(() => {
            // console.log('OK')
          }).onCancel(() => {
            // console.log('Cancel')
          }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          })
        }
      });
    }

    return {
      main_menu,
      sub_menu,
      menu_type,
      extensions,
      buy_years_options,

      main_data,
      menu_data,
      menu_item,

      current_menu_main_index,
      current_menu_sub_index,
      current_menu,
      current_base_amount,
      current_menu_total,
      discount_amount,

      edit_state,

      show_img,
      current_img,

      search_system_name,
      search_password,

      add_main_menu,
      add_sub_menu,
      edit_menu,
      delete_menu,

      cancel_menu,
      rewrite_menu,
      save_menu,

      click_menu,
      click_sub_menu,

      cancel_menu_type,

      submit_quotes,
      search_quotes,

      select_buy_years,

      tab: ref('quotes_tab'),
      innerTab: ref('innerMails'),
      splitterModel: ref(20)
    }
  }
}
</script>
  
<style scoped>
@media (min-width: 576px) {

  .topbanner,
  .contentbody {
    max-width: 540px
  }
}

@media (min-width: 768px) {

  .topbanner,
  .contentbody {
    max-width: 720px
  }
}

@media (min-width: 992px) {

  .topbanner,
  .contentbody {
    max-width: 960px
  }
}

@media (min-width: 1200px) {

  .topbanner,
  .contentbody {
    max-width: 1140px
  }
}



.topbanner,
.contentbody {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}



.contentbody {
  margin-top: 65px;
  padding-bottom: 65px;
  /* 确保内容不被标题栏遮挡 */
  height: 100vh;
  /* 使用视口高度，自动适应屏幕 */
  overflow-y: auto;
  /* 显示垂直滚动条 */
  background-color: #fff;
}

.menu_active {
  background-color: rgba(115, 187, 255, 0.5);
}

.div-disable {
  /* pointer-events: none; */
  cursor: not-allowed;
  opacity: 0.7;
  /* 可以设置透明度来让禁用状态更明显 */
  /* 这里可以添加其他样式以显示禁用状态，例如更改背景颜色、文字颜色等 */
}
</style>

<style >
.q-item {
  cursor: pointer;
  background-color: transparent;
  transition: background-color 0.3s ease;
}

.q-item:hover {
  background-color: rgba(173, 173, 173, 0.4);
}
</style>